<div class="modal-header">
  <div class="d-flex flex-column">
    <h4 class="modal-title">{{ 'response.automatic.caption.title' | translate }}</h4>
    <span class="text-muted text-break">{{ subtitle }}</span>
  </div>
  <button
    type="button"
    class="btn-close"
    [disabled]="uploading"
    [attr.aria-label]="'response.automatic.caption.close' | translate"
    (click)="close()">
  </button>
</div>

<div class="modal-body">
  @if (isImage) {
    <div class="caption-dialog__preview rounded bg-light d-flex align-items-center justify-content-center mb-3">
      <img
        class="rounded mw-100 mh-100 object-fit-contain"
        [src]="previewUrl"
        [alt]="'response.automatic.caption.imageAlt' | translate"
        (error)="onImageError($event)" />
    </div>
  } @else {
    <div class="d-flex align-items-center gap-3 border rounded bg-light p-3 mb-3">
      <div class="avatar-md flex-shrink-0">
        <span class="avatar-title rounded bg-primary-subtle text-primary fw-bold">{{ extension }}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="fw-bold text-dark text-break">{{ filename }}</span>
        @if (size) {
          <small class="text-muted">{{ size }}</small>
        }
      </div>
    </div>
  }

  <label class="form-label" for="response-caption">{{ 'response.automatic.caption.label' | translate }}</label>
  <textarea
    id="response-caption"
    class="form-control"
    rows="4"
    [(ngModel)]="message"
    [attr.maxlength]="limit"
    #captionInput>
  </textarea>

  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-1 position-relative">
    <div class="d-flex align-items-center">
      <button
        type="button"
        class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
        [title]="'response.automatic.bold' | translate"
        (click)="applyFormat('bold')">
        <i class="ri-bold"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
        [title]="'response.automatic.italic' | translate"
        (click)="applyFormat('italic')">
        <i class="ri-italic"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
        [title]="'response.automatic.strikethrough' | translate"
        (click)="applyFormat('strikethrough')">
        <i class="ri-strikethrough"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
        [title]="'response.automatic.emojis' | translate"
        (click)="showEmoji = !showEmoji">
        <i class="ri-emotion-happy-line"></i>
      </button>
      <div class="dropdown">
        <button
          class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          [title]="'response.automatic.variables' | translate">
          <i class="ri-code-line"></i>
        </button>
        <ul class="dropdown-menu">
          @for (variable of templateVariableResponseAutomatedList; track variable.value) {
            <li>
              <a class="dropdown-item" href="#" (click)="addVariable(variable.value); $event.preventDefault()">
                <i class="ri-{{ variable.icon }} me-2"></i>
                {{ variable.label }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>

    @if (limit) {
      <small [class.text-muted]="!excess" [class.text-danger]="excess">
        {{ message.length }} / {{ limit | number }}
        @if (excess) {
          · {{ 'response.automatic.captionReduce' | translate: { count: excess } }}
        }
      </small>
    }

    @if (showEmoji) {
      <div class="position-absolute top-100 start-0 z-3">
        <emoji-mart (emojiSelect)="addEmoji($event)" [darkMode]="false" />
      </div>
    }
  </div>

  <small class="text-muted d-block mt-2">{{ help }}</small>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" [disabled]="uploading" (click)="close()">
    {{ 'response.automatic.caption.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="uploading || excess > 0" (click)="apply()">
    @if (uploading) {
      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
    }
    {{ 'response.automatic.caption.apply' | translate }}
  </button>
</div>
